import { html } from 'common-tags';

// prettier-ignore
export const fields = html`
<ul data-element="fields">
{% if email != blank %}
  <li>
    <i class="os-icon-mail"></i>
    <a href="mailto:{{ email }}">{{ email }}</a>
    <small>Email</small>
  </li>
{% endif %}
{% if phone != blank %}
  <li>
    <i class="os-icon-phone"></i>
    <a href="tel:{{ phone }}">{{ phone }}</a>
    <small>Phone</small>
  </li>
{% endif %}
{% if mobile != blank %}
  <li>
    <i class="os-icon-smartphone"></i>
    <a href="tel:{{ mobile }}">{{ mobile }}</a>
    <small>Mobile</small>
  </li>
{% endif %}
{% if office != blank %}
  <li>
    <i class="os-icon-briefcase"></i>
    <span>{{ office }}</span>
    <small>Office</small>
  </li>
{% endif %}
{% if whatsapp != blank %}
  <li>
    <i class="os-icon-message-circle"></i>
    <span>{{ whatsapp }}</span>
    <small>WhatsApp</small>
  </li>
{% endif %}
{% if address != blank %}
  <li>
    <i class="os-icon-home"></i>
    <span>{{ address }}</span>
    <small>Address</small>
  </li>
{% endif %}
{% if city != blank %}
  <li>
    <i class="os-icon-map-pin"></i>
    <span>{{ city }}</span>
    <small>City</small>
  </li>
{% endif %}
{% if state != blank %}
  <li>
    <i class="os-icon-map"></i>
    <span>{{ state }}</span>
    <small>State</small>
  </li>
{% endif %}
{% if website != blank %}
  <li>
    <i class="os-icon-globe"></i>
    <a href="{{ website }}" target="_blank"> {{ website }} </a>
    <small>Website</small>
  </li>
{% endif %}
{% if linkedin != blank %}
  <li>
    <i class="os-icon-linkedin"></i>
    <a href="{{ linkedin }}" target="_blank">Connect on LinkedIn</a>
    <small>LinkedIn</small>
  </li>
{% endif %}
{% if facebook != blank %}
  <li>
    <i class="os-icon-facebook"></i>
    <a href="{{ facebook }}" target="_blank">Follow on Facebook</a>
    <small>Facebook</small>
  </li>
{% endif %}
{% if instagram != blank %}
  <li>
    <i class="os-icon-instagram"></i>
    <a href="{{ instagram }}" target="_blank">Follow on Instagram</a>
    <small>Instagram</small>
  </li>
{% endif %}
{% if twitter != blank %}
  <li>
    <i class="os-icon-twitter-x"></i>
    <a href="{{ twitter }}" target="_blank">Follow on X</a>
    <small>X</small>
  </li>
{% endif %}
{% if youtube != blank %}
  <li>
    <i class="os-icon-youtube"></i>
    <a href="{{ youtube }}" target="_blank">Subscribe on YouTube</a>
    <small>YouTube</small>
  </li>
{% endif %}
{% if tiktok != blank %}
  <li>
    <i class="os-icon-tiktok"></i>
    <a href="{{ tiktok }}" target="_blank">Follow on TikTok</a>
    <small>TikTok</small>
  </li>
{% endif %}
</ul>`;

export const hoverBorder = {
  style: html`
    <style>
      .interacting {
        cursor: pointer;
        outline: 2px dashed #0066eb;
      }

      .data-element-label {
        background: #0066eb;
        border-radius: 1rem;
        color: #fff;
        display: none;
        font-family: 'Rubik', sans-serif;
        font-size: 0.65rem;
        padding: 0.25rem 0.5rem;
        position: absolute;
        text-transform: uppercase;
        white-space: nowrap;
        z-index: 1000;
      }
    </style>
  `,
  body: html`
    <script>
      const label = document.createElement('div');

      label.className = 'data-element-label';
      document.body.appendChild(label);

      document.addEventListener('mouseover', function (e) {
        const target = e.target.closest('[data-element]');
        if (!target) return;

        target.classList.add('interacting');

        const text = target.getAttribute('data-element');
        const formatted = text.replace(/-/g, ' ');
        label.textContent = formatted;

        requestAnimationFrame(() => {
          const rect = target.getBoundingClientRect();
          const padding = 6;

          label.style.display = 'block';

          const labelRect = label.getBoundingClientRect();
          const spaceAbove = rect.top;
          const shouldPlaceAbove = spaceAbove > labelRect.height + padding;

          const top = shouldPlaceAbove
            ? rect.top + window.scrollY - labelRect.height - padding
            : rect.bottom + window.scrollY + padding;

          const left = rect.right + window.scrollX - label.offsetWidth;

          label.style.top = top + 'px';
          label.style.left = left + 'px';
        });
      });

      document.addEventListener('mouseout', function (e) {
        const target = e.target.closest('[data-element]');

        if (target) {
          label.style.display = 'none';

          target.classList.remove('interacting');
        }
      });

      document.addEventListener(
        'click',
        function (e) {
          const element = e.target.closest('[data-element]');

          if (element) {
            e.preventDefault();
            e.stopPropagation();

            let target = element?.dataset.element;

            target = target.replace(/-/g, '_');

            if (target.startsWith('card') || target.startsWith('header')) {
              const parts = target.split('_');
              target = parts.slice(0, 1).join('_');
            }

            window.top.parent.postMessage(
              {
                source: 'card',
                target: target
              },
              '*'
            );
          }
        },
        true
      );
    </script>
  `
};
